import React from "react";
import "./AipChangeCenterTable.css";
import {
  getChangeAvatarStyle,
  renderChangeDelta,
  renderChangeNote,
  renderChangeDate,
} from "../utils/aipChangeCenterUi";

const ROW_CLASS = "aip-change-table-row";

const AipChangeCenterTable = ({ rows, onClientClick, nameClassName = "" }) => (
  <div className="aip-change-table" role="table" aria-label="AIP score changes">
    <div className={`${ROW_CLASS} aip-change-table-head`} role="row">
      <div className="aip-change-table-cell aip-change-col-client" role="columnheader">
        Client
      </div>
      <div className="aip-change-table-cell aip-change-col-date" role="columnheader">
        Last Update
      </div>
      <div className="aip-change-table-cell aip-change-col-num is-num" role="columnheader">
        Previous
      </div>
      <div className="aip-change-table-cell aip-change-col-num is-num" role="columnheader">
        Current
      </div>
      <div className="aip-change-table-cell aip-change-col-num is-num" role="columnheader">
        Change
      </div>
      <div className="aip-change-table-cell aip-change-col-notes" role="columnheader">
        AIP Score Change Explanation
      </div>
    </div>

    {rows.map((row) => {
      const avatarStyle = getChangeAvatarStyle(row.clientId);
      const clientLabel = row.clientName || "client";
      return (
        <div
          key={row.clientId}
          className={`${ROW_CLASS} aip-change-table-data is-clickable`}
          role="row"
          onClick={() => onClientClick(row.clientId)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClientClick(row.clientId);
            }
          }}
          tabIndex={0}
          aria-label={`View ${clientLabel} AIP details`}
        >
          <div className="aip-change-table-cell aip-change-col-client" role="cell">
            <div className="aip-change-client">
              <span
                className="aip-change-avatar"
                style={{
                  backgroundColor: avatarStyle.bg,
                  color: avatarStyle.color,
                }}
              >
                {(row.clientName || "?").trim().charAt(0).toUpperCase()}
              </span>
              <span className={`aip-change-name ${nameClassName}`.trim()}>
                {row.clientName}
              </span>
            </div>
          </div>
          <div className="aip-change-table-cell aip-change-col-date" role="cell">
            {renderChangeDate(row.changeDate)}
          </div>
          <div className="aip-change-table-cell aip-change-col-num is-num aip-change-prev" role="cell">
            {row.previousScore != null && row.previousScore !== ""
              ? row.previousScore
              : "—"}
          </div>
          <div className="aip-change-table-cell aip-change-col-num is-num aip-change-curr" role="cell">
            {row.currentScore != null ? row.currentScore : "—"}
          </div>
          <div className="aip-change-table-cell aip-change-col-num is-num aip-change-delta" role="cell">
            {renderChangeDelta(row.change)}
          </div>
          <div className="aip-change-table-cell aip-change-col-notes" role="cell">
            {renderChangeNote(row.note)}
          </div>
        </div>
      );
    })}
  </div>
);

export default AipChangeCenterTable;
